import { FieldId as I } from "@perxis-auto/trade-in-sdk/types";
const O = [
  I.PRODUCTION_YEAR,
  I.DRIVETRAIN,
  I.BODY_TYPE,
  I.MILEAGE,
  I.MODIFICATION,
  I.LOCATION
];
export {
  O as SUCCESS_TABLE_FIELD_IDS
};
